'use client';
import { useI18n } from '@/components/public/i18n/LocaleProvider';
import { RNODE_CASES, RNODE_CASES_URL } from '@/lib/public/rnode-cases';
import { Arrow } from './Icons';

export default function RNodeCases() {
  const { t, href } = useI18n();
  return (
    <section className="u-rnode-cases" aria-labelledby="rnode-cases-title">
      <p className="u-eyebrow">{t('Huit métiers. Des situations concrètes.')}</p>
      <h2 id="rnode-cases-title">{t("Partez d’un cas proche de votre activité.")}</h2>
      <p>{t("Découvrez le parcours qui vous ressemble, puis demandez à Élina de l’adapter à votre entreprise.")}</p>
      <div className="u-rnode-case-grid">
        {RNODE_CASES.map((item, index) => (
          <a key={item.id} href={href(`${RNODE_CASES_URL}/${item.id}/`)}>
            <span className="u-rnode-case-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
            <span><strong>{t(item.label)}</strong><small>{t(item.tag)}</small></span>
            <Arrow diagonal />
          </a>
        ))}
      </div>
    </section>
  );
}

